import React from 'react';
import TextEffect from './TextEffect';
import './HeroBanner.css';

const HeroBanner = () => {
  // Log pour vérifier le montage
  console.log('HeroBanner rendu');

  return (
    <div className="hero-container">
      <div className="hero-grid">
        <div className="hero-image">
          <img
            src="/images/home3.png"
            alt="Hero placeholder"
            className="hero-img"
          />
        </div>
        <div className="hero-text">
          <TextEffect />
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;